import {Component, inject} from '@angular/core';
import {TypeProjectDetailedWithoutUnresolvableLinksResponse} from '../../../../core/types/contentful.types';
import {toSignal} from '@angular/core/rxjs-interop';
import {ContentfulService} from '../../../../core/services/contentful.service';

@Component({
    selector: 'wci-detailed-projects',
    imports: [],
    templateUrl: './detailed-projects.component.html',
    styles: ``,
})
export class DetailedProjectsComponent {
    service = inject(ContentfulService);
    items = toSignal<TypeProjectDetailedWithoutUnresolvableLinksResponse[]>(this.service.getDetailedProjects());
}
